import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GeneralHelper } from '@shared/helpers';
import { environment } from '@environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ApiSeqService {
    private http = inject(HttpClient);

    private readonly API_SEQ_URL = `${environment.apiSeqUrl}/`;

    get(path: string, params = {}, responseType?: any, observe: 'body' | 'response' = 'body'): Observable<any> {
        const trimmedParams = GeneralHelper.trimStrings(params);
        const trimmedPath = path.replace(/\s/g, '');

        return this.http
            .get(`${this.API_SEQ_URL}${trimmedPath}`, {
                params: trimmedParams,
                responseType: responseType ?? undefined,
                observe: observe as any,
            })
            .pipe(
                catchError(error => {
                    console.error(error);
                    if (error.error === 'login_required') {
                        window.location.reload();
                    }
                    return throwError(() => error);
                })
            );
    }

    put(path: string, body = {}): Observable<any> {
        const trimmedBody = GeneralHelper.trimStrings(body);
        const trimmedPath = path.replace(/\s/g, '');

        return this.http.put(`${this.API_SEQ_URL}${trimmedPath}`, trimmedBody).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(() => error);
            })
        );
    }

    post(path: string, body = {}, params = {}): Observable<any> {
        const trimmedBody = GeneralHelper.trimStrings(body);
        const trimmedParams = GeneralHelper.trimStrings(params);
        const trimmedPath = path.replace(/\s/g, '');

        return this.http.post(`${this.API_SEQ_URL}${trimmedPath}`, trimmedBody, { params: trimmedParams }).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(() => error);
            })
        );
    }

    patch(path: string, body = {}, params = {}): Observable<any> {
        const trimmedBody = GeneralHelper.trimStrings(body);
        const trimmedParams = GeneralHelper.trimStrings(params);
        const trimmedPath = path.replace(/\s/g, '');

        return this.http.patch(`${this.API_SEQ_URL}${trimmedPath}`, trimmedBody, { params: trimmedParams }).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(() => error);
            })
        );
    }

    delete(path: string): Observable<any> {
        const trimmedPath = path.replace(/\s/g, '');

        return this.http.delete(`${this.API_SEQ_URL}${trimmedPath}`, {}).pipe(
            catchError(error => {
                if (error.error === 'login_required') {
                    window.location.reload();
                }
                return throwError(() => error);
            })
        );
    }
}
